
export default {
  altitudePreview: {
    'expandAltitudeChart': 'Ingrandisci grafico',
    'altitude': 'Altitudine'
  }
}
